import React from 'react'
import AddressCard from '../AddressCard/AddressCard'
import CartItem from '../Cart/CartItem'

export default function OrderSummary() {
  return (
    <div>
      <div className='p-5 shadow-lg rounded-s-md border'>
        <AddressCard/>
      </div>
      <div className='pt-5'>
            <div className='lg:grid grid-cols-3 relative'>
                <div className='col-span-2'>
                    {/* {[1,1,1,1].map((item)=><CartItem />)} */}
                    
                </div>
                <div className='px-5 sticky top-0 h-[100vh] mt-5 lg:mt-0'>
                    <div className='border'>

                        <p className='uppercase font-bold opacity-60 pb-4'>Hóa đơn thanh toán</p>
                        <hr/>
                        <div className='space-y-3 font-semibold mb-10'>
                            <div className='flex justify-between pt-3 text-black'>
                                <span>Tổng số lượng :</span>
                                <span>5</span>
                            </div>
                            <div className='flex justify-between pt-3'>
                                <span>Tổng số tiền :</span>
                                <span>5,000,000</span>
                            </div>
                            <div className='flex justify-between pt-3 '>
                                <span>Phí giao hàng :</span>
                                <span>500,000</span>
                            </div>
                            <div className='flex justify-between pt-3  font-bold'>
                                <span>Tổng thanh toán :</span>
                                <span>5,500,000</span>
                            </div>
                        </div>
                        
                    </div>
                </div>

            </div>

        </div>
    </div>
  )
}
